import { collection, doc, setDoc, Timestamp } from 'firebase/firestore';
import { getCtData } from '../../project';
import { firestoreOutFlax } from './firebase';
import { sanitizeForFirebase } from './utils';

export const css1 =
  'color: green; background-color: black; font-size: 11px; padding: 2px 6px; border-radius: 3px';
export const css2 =
  'color: yellow; background-color: green; font-size: 10px; padding: 2px 6px; border-radius: 3px';

type Tprops = {
  args: any;
  pass: {
    fbInit: any;
    arrRefStrings: string[];
    arrPathData: string[];
    arrFuncs: any[];
  };
};

export const setDocTool = async (props: Tprops) => {
  // ---------- set Props
  const { args, pass } = props;
  const { arrRefStrings, arrPathData, arrFuncs } = pass;

  // ---------- set Local Imports
  // const { doc, setDoc, collection, Timestamp } = await import(
  //   '@firebase/firestore'
  // );

  // ---------- set Caps Inputs
  // let fbInit = [!#!firestore init path!#!];
  // let newArrRef = [!#!array firestore reference!#!];
  // const arrayData = [!#!data to set!#!];
  // const arrFuncs = [!#!functions return!#!];

  // -----------------------------
  // ---------- set Firestore Call
  // -----------------------------
  // const fireInit = getFirestore(fbInit[0], firestoreId);
  const refColl = collection(firestoreOutFlax, ...arrRefStrings);
  const refDoc = doc(refColl);

  // ------ check Data
  if (!Array.isArray(arrRefStrings))
    return console.log(
      'arrRefStrings needs to be a string array',
      arrRefStrings,
    );

  // ------ read Data
  let dataToSet = {};
  dataToSet = getCtData(arrPathData.join());
  console.log({ dataToSet });

  // ------ add new id
  dataToSet.docId = refDoc.id;
  dataToSet.createdAt = Timestamp.now();

  const sanitizedData = sanitizeForFirebase(dataToSet);

  await setDoc(refDoc, sanitizedData).catch(err =>
    console.log('Erro do setDoc', { err }),
  );

  // ---------- set Get Value Functions
  for (const currFunc of arrFuncs) await currFunc(sanitizedData, args);

  console.log('%csetDoc ok', css1);
  console.log('%cReferencia do Documento', css2, {
    arrRefStrings,
    sanitizedData,
  });

  return sanitizedData;
};
